var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "header-actions" },
            [
              _c("CorpId"),
              _vm._v(" "),
              _c("CompassButton", {
                staticClass: "ml-3",
                attrs: {
                  label: _vm.$t.__("developerPage.MyApps.add_application"),
                  type: "primary"
                },
                on: { click: _vm.createApp }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: "mt-0" }, [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$l10n.__(
                    "Cette section est réservée aux développeurs, vous retrouvez ici l'ensemble des applications que vous avez créées et utilisant l'API Sellsy"
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n        " +
                _vm._s(
                  _vm.$l10n.__(
                    "Si vous êtes développeur, vous pourrez trouver les informations nécessaires au développement de votre application sur le site de l'API"
                  )
                ) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.apps, function(consumer) {
            return _c("consumer", {
              key: consumer.token_id,
              attrs: { consumer: consumer }
            })
          })
        ],
        2
      )
    : _c("preloader", { attrs: { background: false, display: true } })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }